<template>
    <router-link :to="{name: 'products_all' , query:{category: data?.id}}" class="category d-block">
        <div class="image">
            <img v-if="data?.image" class="rounded" :src="data?.image" alt="">
            <img v-else src="@/assets/home/default.png" alt="" style="opacity: 0.5;">
        </div>
        <div class="product-info">
            <h3>{{ data?.name }}</h3>
        </div>
    </router-link>
</template>
<script>
export default {
    name: 'CategoryBoxComponent',
    props: ['data']
}
</script>
<style scoped>
.category {
    all: unset;
    display: block;
    padding: 0.8rem;
    border-radius: 8px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    margin: 0 0.5rem 1rem;
    cursor: pointer;
}

.category .image {
    height: 300px;
    width: 100%;
}

.category .image img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.category .product-info {
    padding: 1rem 0;
}

.category .product-info h3 {
    color: #62825D;
}
</style>